import { render, staticRenderFns } from "./journal-entries.vue?vue&type=template&id=af1df910&scoped=true"
import script from "./journal-entries.vue?vue&type=script&lang=js"
export * from "./journal-entries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1df910",
  null
  
)

export default component.exports